// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3g1qh","type":"styles_type__2uElZ","choices":"styles_choices__1dpFa"};